import { Component } from '@angular/core';
import { LoaderService } from './data/services/loader.service';
import { UserService } from './data/services/user.service';
import { Helper } from './shared/helper';
import { LangService } from './shared/lang.service';
import { AuthService } from './shared/auth.service';
import { LanguageService } from './shared/language.service';
import { AdminSettingsService } from './shared/admin-settings.service';
import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { SeoConfig, SeoService } from './shared/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'KB Imitation';
  isLoading: boolean = true;
  hideLayout = false;
  constructor(private router: Router,private langconfig: LanguageService,private _authService: AuthService,public loader : LoaderService , private adminSettingsService : AdminSettingsService, public helper:Helper, private seoService: SeoService){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.hideLayout = event.url.includes('/too-many-requests');
        this.applyRouteSeo();
      }
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.langconfig.init().then(() => {
      this.adminSettingsService.getAdminDetails().subscribe({
        next: async (adminDetails:any) => {
          if(adminDetails[0].iconImage && adminDetails[0].iconImage[0]){
            const iconUrl = environment.IMAGE_URL + adminDetails[0].iconImage[0];
            this.setFavicon(iconUrl);
          }
         await this._authService.autologin().then(() => {
          });
        },
        error: (error) => {
          console.error('Error during initialization:', error);
        },
        complete: () => {
          this.isLoading = false;
          this.applyRouteSeo();
        }
      });
    });
  }

  setFavicon(iconUrl: string): void {
    const link: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = iconUrl;

    if (!link.parentNode) {
      document.head.appendChild(link);
    }
  }

  private applyRouteSeo(): void {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    const config = route.data['seo'] as Omit<SeoConfig, 'canonicalPath'> | undefined;
    if (!config) return;

    this.seoService.update({
      ...config,
      canonicalPath: this.router.url.split('?')[0],
    });
  }
}
